import styled from 'styled-components';

export const Map = styled.div`
    height: 400px;
    width: 100%;
    z-index: 1;
    border: 1px solid #fff;
    -moz-border-radius: 8px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;

    iframe {
        width: 100%;
        height: 100%;
    }
`;

export const Overlay = styled.div`
    width: 100%;
    height: 100%;
    z-index: 1;
    position: absolute;
    display: ${props => (props.displayOverlay ? 'flex' : 'none')};
    align-items: start;
    justify-content: center;
    background: rgba(0, 0, 0, 0.1);
`;
